const header = {
  height: 78,
  heightMobile: 60,
  filters: 66
}

const search = {
  height: header.height + 20,
  heightMobile: header.heightMobile + 10
}

const map = {
  activeFilters: 36,
  activeFiltersMobile: 41,
  listWidthTriple: 1040,
  listWidthDouble: 700,
  listWidthSingle: 360
}

const page = {
  width: 1240
}

const footer = {
  height: 361,
  minimal: {
    height: 62
  }
}

// recalibrated dimensions
const mobile = {
  header: 60,
  heroImageHeight: 250,
  search: 48, // search control height
  searchWrapper: 56,
  actions: 57,
  activeFilters: 32,
  footer: 65, // create alert in city page
  gutter: 16
}

const desktop = {
  page: 1280,
  heroImageHeight: 448,
  rightPanel: 416,
  header: 78,
  search: 48,
  gutter: 32
}

const signup = {
  form: 600, // max width for both mobile/desktop
  mobile: {
    footer: 85
  }
}

const structure = {
  header,
  search,
  page,
  footer,
  map,
  mobile,
  desktop,
  signup
}

export default structure
